export enum EMsessageType {
    Group = 0,
    Private = 1
}